<template>
  <aside class="admin-sidebar" :class="{ open: isOpen }">
    <div class="brand">
      <div class="brand-mark">
        <img :src="logoUrl" alt="Optometry Clinic" />
      </div>
      <div>
        <strong>Optometry Clinic</strong>
        <span>Admin panel</span>
      </div>
    </div>
    <nav class="sidebar-nav">
      <router-link to="/" @click="$emit('navigate')">
        <span class="nav-icon"><span class="fas fa-chart-line"></span></span>
        <span class="nav-label">Обзор</span>
      </router-link>

      <router-link to="/categories" @click="$emit('navigate')">
        <span class="nav-icon"><span class="fas fa-tags"></span></span>
        <span class="nav-label">Категории</span>
      </router-link>

      <router-link
        v-for="item in visibleCollectionNav"
        :key="item.to"
        :to="item.to"
        :class="{ 'router-link-active': item.feedbackGroup && $route.path.startsWith('/feedback') }"
        @click="$emit('navigate')"
      >
        <span class="nav-icon"><span :class="`fas ${item.icon}`"></span></span>
        <span class="nav-label">{{ item.label }}</span>
      </router-link>

      <div class="nav-group">
        <button
          class="nav-group-toggle"
          type="button"
          @click="toggleGroup('seo')"
        >
          <span class="nav-icon"><span class="fas fa-search"></span></span>
          <span class="nav-label">SEO</span>
          <span
            class="fas fa-chevron-down nav-chevron"
            :class="{ open: openedGroups.seo }"
          ></span>
        </button>
        <div class="nav-sublist" v-show="openedGroups.seo">
          <router-link
            v-for="item in visibleSeoNav"
            :key="item.to"
            :to="item.to"
            @click="$emit('navigate')"
          >
            {{ item.label }}
          </router-link>
        </div>
      </div>

      <div class="nav-group">
        <button
          class="nav-group-toggle"
          type="button"
          @click="toggleGroup('pages')"
        >
          <span class="nav-icon"><span class="fas fa-file-alt"></span></span>
          <span class="nav-label">Страницы</span>
          <span
            class="fas fa-chevron-down nav-chevron"
            :class="{ open: openedGroups.pages }"
          ></span>
        </button>
        <div class="nav-sublist" v-show="openedGroups.pages">
          <router-link
            v-for="item in pageNav"
            :key="item.to"
            :to="item.to"
            @click="$emit('navigate')"
          >
            {{ item.label }}
          </router-link>
        </div>
      </div>

      <router-link to="/logs" @click="$emit('navigate')">
        <span class="nav-icon"><span class="fas fa-history"></span></span>
        <span class="nav-label">Журнал действий</span>
      </router-link>
    </nav>
    <div class="sidebar-language">
      <LanguageSwitcher />
    </div>
    <div
      ref="userDropdown"
      class="dropup user-box sidebar-user-box motion-dropdown"
    >
      <button
        class="user-box-toggle"
        type="button"
        data-bs-toggle="dropdown"
        aria-expanded="false"
      >
        <span class="user-box-avatar">
          <img v-if="authUserImage" :src="authUserImage" :alt="authUserEmail" />
          <span v-else>{{ authUserInitials }}</span>
        </span>
        <span class="user-box-meta">
          <strong>{{ authUserName || authUserEmail }}</strong>
          <small>{{ authUserRole }}</small>
        </span>
        <span class="fas fa-chevron-up"></span>
      </button>
      <div class="dropdown-menu user-box-menu motion-dropdown-menu">
        <router-link
          class="dropdown-item"
          to="/settings"
          @click="$emit('navigate')"
        >
          <span class="fas fa-cog"></span>
          Настройки
        </router-link>
        <div class="dropdown-divider"></div>
        <button
          class="dropdown-item text-danger"
          type="button"
          @click="$emit('logout')"
        >
          <span class="fas fa-sign-out-alt"></span>
          Logout
        </button>
      </div>
    </div>
  </aside>
</template>

<script>
import Dropdown from "bootstrap/js/dist/dropdown";
import logoUrl from "../assets/Images/logo.svg";
import LanguageSwitcher from "./LanguageSwitcher.vue";

const DROPDOWN_MOTION_MS = 160;

export default {
  components: {
    LanguageSwitcher,
  },
  emits: ["logout", "navigate"],
  props: {
    isOpen: { type: Boolean, default: false },
    authUserEmail: { type: String, default: "" },
    authUserName: { type: String, default: "" },
    authUserRole: { type: String, default: "" },
    authUserImage: { type: String, default: "" },
    authUserInitials: { type: String, default: "A" },
  },
  data() {
    return {
      logoUrl,
      dropdownMotionTimer: null,
      isDropdownClosing: false,
      openedGroups: {
        pages: false,
        seo: false,
      },
      seoNav: [
        { to: "/seo/global", label: "Общие настройки" },
        { to: "/seo/pages", label: "Страницы" },
        { to: "/seo/entities", label: "Сущности" },
        { to: "/seo/scripts", label: "Скрипты и метрики", adminOnly: true },
      ],
      pageNav: [
        { to: "/pages/general", label: "Общее" },
        { to: "/pages/home", label: "Главная" },
        { to: "/pages/about", label: "О клинике" },
        { to: "/pages/services", label: "Услуги" },
        { to: "/pages/serviceDetail", label: "Детальная услуга" },
        { to: "/pages/prices", label: "Прайс" },
        { to: "/pages/shop", label: "Магазин" },
        { to: "/pages/blog", label: "Блог" },
        { to: "/pages/contacts", label: "Контакты" },
      ],
      collectionNav: [
        {
          to: "/users",
          label: "Пользователи",
          icon: "fa-user-shield",
          adminOnly: true,
        },
        {
          to: '/service-orders',
          label: 'Заявки на услуги',
          icon: 'fa-calendar-check',
        },
        { to: '/shop-orders', label: 'Заявки магазина', icon: 'fa-shopping-bag' },
        { to: '/feedback/messages', label: 'Обратная связь', icon: 'fa-comments', feedbackGroup: true },
        {
          to: "/collections/clinics",
          label: "Клиники",
          icon: "fa-map-marker-alt",
        },
        {
          to: "/collections/services",
          label: "Услуги",
          icon: "fa-stethoscope",
        },
        { to: "/collections/products", label: "Товары", icon: "fa-glasses" },
        { to: "/collections/articles", label: "Статьи", icon: "fa-newspaper" },
      ],
    };
  },
  computed: {
    visibleCollectionNav() {
      return this.collectionNav.filter(
        (item) => !item.adminOnly || this.$store.getters.isAdmin
      );
    },
    visibleSeoNav() {
      return this.seoNav.filter(
        (item) => !item.adminOnly || this.$store.getters.isAdmin
      );
    },
  },
  methods: {
    syncOpenedGroups() {
      const path = this.$route.path || "";
      if (path.startsWith("/seo")) this.openedGroups.seo = true;
      if (path.startsWith("/pages")) this.openedGroups.pages = true;
    },
    handleDropdownHide(event) {
      const dropdown = this.$refs.userDropdown;
      const menu = dropdown ? dropdown.querySelector(".dropdown-menu") : null;

      if (!menu || this.isDropdownClosing) return;

      event.preventDefault();
      menu.classList.add("is-closing");

      clearTimeout(this.dropdownMotionTimer);
      this.dropdownMotionTimer = setTimeout(() => {
        this.isDropdownClosing = true;
        Dropdown.getOrCreateInstance(
          dropdown.querySelector('[data-bs-toggle="dropdown"]')
        ).hide();
        this.isDropdownClosing = false;
        menu.classList.remove("is-closing");
      }, DROPDOWN_MOTION_MS);
    },
    toggleGroup(groupKey) {
      this.openedGroups[groupKey] = !this.openedGroups[groupKey];
    },
  },
  watch: {
    $route: {
      immediate: true,
      handler() {
        this.syncOpenedGroups();
      },
    },
  },
  mounted() {
    this.$refs.userDropdown.addEventListener(
      "hide.bs.dropdown",
      this.handleDropdownHide
    );
  },
  beforeUnmount() {
    clearTimeout(this.dropdownMotionTimer);
    this.$refs.userDropdown.removeEventListener(
      "hide.bs.dropdown",
      this.handleDropdownHide
    );
  },
};
</script>
